import MediaImage from "@/components/ui/MediaImage";
import { withRichTextRuleColours } from "@/utils/rich-text-rule";
import React, { useLayoutEffect, useRef, useState } from "react";
import Link from "next/link";

interface FlexSectionTileProps {
  forceShowAll?: boolean;
  item: {
    imgurl?: string;
    overskrift: string;
    tekst: string;
    linktext: string;
    link: string;
  };
}

const FlexSectionTile: React.FC<FlexSectionTileProps> = ({
  item,
  forceShowAll,
}) => {
  const [showAll, setShowAll] = useState(forceShowAll ?? false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const descriptionRef = useRef<HTMLDivElement>(null);

  const checkOverflow = () => {
    if (descriptionRef.current) {
      setIsOverflowing(descriptionRef.current.clientHeight > 300);
    }
  };

  useLayoutEffect(() => {
    checkOverflow();
  }, []);

  return (
    <div className={`flex border flex-col bg-white`}>
      <div className="relative h-[210px]">
        {item.imgurl && (
          <MediaImage
            src={item.imgurl}
            alt={`Slide`}
            className="w-full h-[200px] object-cover absolute"
          />
        )}
      </div>
      <div
        className={`flex flex-1 flex-col justify-between ${showAll ? " h-full" : "relative overflow-hidden max-h-[300px]"}`}
      >
        <div className="flex flex-col homepage-text-sm">
          <div
            ref={descriptionRef}
            className={`flex flex-1 flex-col justify-between p-4 ${showAll ? "" : ""}`}
          >
            <div className="homepage-text-lg">{item.overskrift}</div>
            <div
              dangerouslySetInnerHTML={{
                __html: withRichTextRuleColours(item.tekst ?? ""),
              }}
            />
          </div>
          {isOverflowing || item.link ? (
            <div
              className={`p-4 ${showAll || forceShowAll ? "" : "absolute bottom-0 pt-10 z-10 left-0 right-0 bg-gradient-to-b from-white/0 via-30% via-white/100 to-white/100"}`}
            >
              {isOverflowing && (
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="flex w-full py-2 gap-1 items-center font-bold"
                >
                  {showAll ? "Læs mindre" : "Læs mere"}
                </button>
              )}
              {item.link && (
                <Link aria-label="Link" className="font-bold" href={item.link}>
                  {item.linktext ? item.linktext : item.link}
                </Link>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FlexSectionTile;
